import React from 'react';
import { Button, Checkbox, Modal, Popup } from 'semantic-ui-react';

const CollectionToCinempraphSelectionModal = ({
  openModal,
  toggleModal,
  collectionAdPrototypes = [],
  idsOfCollectionAdsToConvert = [],
  alterIdsOfCollectionAdsToConvert,
  fireRelaunch
}) => {
  return (
    <div>
      <Modal
        size="small"
        open={openModal}
        onClose={() => toggleModal(false)}
        closeOnEscape
        closeOnDimmerClick
      >
        <Modal.Header>Convert Collections into Cinemagraphs</Modal.Header>
        <Modal.Content scrolling>
          <Modal.Content>
            <p>
              Among the ads that failed to launch, there were collections ads
              that failed. Please select the collections you would like to
              launch as cinemagraphs from the list below:
            </p>
            <div style={{ maxHeight: '150px', overflowY: 'scroll' }}>
              {collectionAdPrototypes.map((adPrototype) => {
                const { id, name } = adPrototype;
                return (
                  <div style={{ paddingBottom: '0.5em' }}>
                    <Checkbox
                      label={name}
                      onChange={() => {
                        alterIdsOfCollectionAdsToConvert(id);
                      }}
                      checked={idsOfCollectionAdsToConvert.includes(id)}
                    />
                  </div>
                );
              })}
            </div>
          </Modal.Content>
        </Modal.Content>
        <Modal.Actions>
          <Button content="Cancel" onClick={() => toggleModal(false)} />
          <Popup
            trigger={
              <Button
                primary
                content="Relaunch"
                onClick={() => {
                  fireRelaunch();
                  toggleModal(false);
                }}
              />
            }
            position="top right"
            size="mini"
            content="This will relaunch all failed ads in the queue."
          />
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default CollectionToCinempraphSelectionModal;



// WEBPACK FOOTER //
// ./src/components/common/Launcher/CollectionToCinempraphSelectionModal.jsx